import { useState, useEffect, Fragment } from 'react'
import {Helmet} from "react-helmet"
import { useSelector, useDispatch } from 'react-redux'
import { Routes, Route, Link, useLocation, useParams } from "react-router-dom";


import useMedia from "./js/js/useMedia"
import Base64 from "./js/Base64"


import LoginMenu from "./js/HEADER/LoginMenu"
import UserMenu from "./js/HEADER/UserMenu"

import ShapkaPreloader from "./js/HEADER/ShapkaPreloader"
import MainPage_DeskTop from "./js/MainPage_DeskTop"
import MainPage_Mobile from "./js/MainPage_Mobile"
import Login from "./js/LOGIN/Login"
import LogOut from "./js/LOGIN/Logout"
import Registration from "./js/LOGIN/Registration"
import User from "./js/LOGIN/User"
import Passrecovery from "./js/LOGIN/PassRecovery"

import GetInfoBlock from "./js/GetInfoBlock"

import './css/App.css';
import './css/index.css';
import './css/logo.css';

import "./css/login.css";
import "./css/lk.css";
import "./css/editable.css";

import './css/effects.css';
import './css/footer.css';
import './css/styles.css';
import './css/infoblock.css';
import './css/BlueLine.css';
import './css/mob.css'
import './css/loader.css';

import local from './app_localisation';

var rpfx = '';
var rttl = '';
var rman = '';

var renders = 0;
var mainPic = null;

import { SET_NAVBASES, LOAD_NAV_IDS, SET_TOPNAV, SET_LANG } from './redux/reducers/site';

function App(props) {

  const dispatch = useDispatch()
  const setup = useSelector(state => state.site.setup);
  const loged = window.localStorage.uloged;

const domen = {
  'ru':'ru',
  'en':'com',
  'de':'com',
};

  let large = useMedia("(min-width:650px)");

const [NavIDIs, setNavIDIs] = useState({loading:true, error:false});

//const useQuery = () => new URLSearchParams(useLocation().search);

let isHTML = false;

let location = useLocation();
let url = location.pathname;
let parts = url.split('/');
let LANG = parts[1];


 useEffect(() => { 
  //ReactGA.initialize('UA-6337752-1');
  //console.log('SETUP_LANG', LANG);
  LoadNavIDs(LANG); 
  if(NavIDIs.loading){ 
  }
  }, [LANG] );

 
if(NavIDIs.error){
  return <p>AppJS: {NavIDIs.error.message}</p>
} 

return (
  <Fragment>
      <Helmet>
        <title>{local[LANG].title}</title>
        <meta name="description" content={local[LANG].description} />
        <meta name="keywords" content={local[LANG].keywords} />      
      </Helmet>
        <div className="App">
          {
            large ? //Десктоп версия
            <Fragment>
              <div className='LogoPlate'>
                <div>
                  <a href={'https://condtrol.'+domen[LANG]} title={local[LANG].gotosite}>
                    <img src={setup.domen+'svg/LOGO_CONDTROL.svg'} className="logo" alt=""/>
                  </a>
                  {
                    NavIDIs.loading ? null 
                    : 
                    <Fragment>
                      {
                        loged? <UserMenu/> : <LoginMenu/>
                      }
                    </Fragment>
                  }
                </div>
              </div> 
              <div className='RedLine'>
                <span>{local[LANG].redline}</span>
              </div>
            </Fragment>
          : //мобильная версия
          <Fragment>
          <div className='LogoPlate'>
            <a href='https://condtrol.ru' title=''>
              <img src={setup.domen+'svg/LOGO_CONDTROL.svg'} className="logo" alt={local[LANG].gotosite}/>
            </a>
            {
            NavIDIs.loading ? null
            : 
            <Fragment>
              {
                loged? <UserMenu/> : <LoginMenu/>
              }
            </Fragment>
            }
          </div> 
          <div className='RedLine'>
               <span>{local[LANG].redline}</span>
           </div>
          </Fragment>
          }
          
          {
              NavIDIs.loading ? 
              <ShapkaPreloader/>
              :
              <Fragment>
                {
//                  <TopTelephones/>
                }
                
                <Routes>
                      <Route exact path="/:lang" element={<RHome/>}/>
                      <Route exact path="/:lang/home" element={<RHome/>}/>
                      <Route exact path="/:lang/login" element={<RLogin/>}/>
                      <Route exact path="/:lang/user" element={<RUser/>}/>
                      <Route exact path="/:lang/logout" element={<RLogOut/>}/>
                      <Route exact path="/:lang/signup" element={<RRegistration/>}/>
                      <Route exact path="/:lang/precovery" element={<RPassRecovery/>}/>
                </Routes>
              </Fragment>
            }

        </div>
    </Fragment>
  );

  function RHome(){
    return(
    <Fragment>
      <div className='BlueLine'>
        <img src={setup.domen+'pics/'+mainPic} className='MainPic'/>
      </div>
      <section>
        {
        large? <MainPage_DeskTop /> : <MainPage_Mobile lang={LANG} />
        }
      </section>
      <Footer tel={true}/>
    </Fragment>
    )
  }


  function RLogin() {
    return (
      <Fragment>
        <div className='BlueLine fbg'>
          <Login />
          <img src={setup.domen+'pics/'+mainPic} className='LoginBG'/>
        </div>
        <section className='tac ftab'>
          <div className='pages'>
            <GetInfoBlock blk='agree' ttl="yes"/>
          </div>
        </section>
        <Footer tel={true}/>
      </Fragment>
    )
  }

  function RRegistration() {
    return (
      <Fragment>
        <div className='BlueLine fbg'>
          <Registration />
          <img src={setup.domen+'pics/'+mainPic} className='LoginBG'/>
        </div>
        <section className='tac ftab'>
          <div className='pages'>
            <GetInfoBlock blk='agree' ttl="yes"/>
          </div>
        </section>
        <Footer tel={true}/>
      </Fragment>
    )
  }

  function RPassRecovery() {
    return (
      <Fragment>
        <div className='BlueLine fbg'>
          <Passrecovery />
          <img src={setup.domen+'pics/'+mainPic} className='LoginBG'/>
        </div>
        <section></section>
        <Footer tel={true}/>
      </Fragment>
    )
  }
  

  function RUser() {
    return (
    <Fragment>
      <div className='BlueLine'>
        <User />
      </div>
      <section></section>
      <Footer tel={true}/>
    </Fragment>
    )
  }

  function RLogOut() {
    return (
      <div className='BlueLine'>
        <LogOut />
      </div>
    )
  }
  
  function LoadNavIDs(lang){
    setNavIDIs({ error:false, loading:true });
  const form = new FormData()
        form.append('baseQ', setup.bases);
        form.append('lang', lang+'/');
  const MyInit = { method: 'POST', body: form };
  fetch(setup.domen+setup.folder+'init', MyInit )
    .then(response => {
      if (response.ok) {
        return response.json();
        } else {
          throw new Error(response.text()+'Something went wrong ...');
        }
      })
    .then(data => { 
      rman = data.itm.man;
      rpfx = data.itm.pfx;
      rttl = data.itm.ttl;

/*
      if(rttl !=='none') { title = ''; }
      if(rman !== 'none') { title = rman+' ' }
      if(rttl !=='none') { title = title+rttl; }
      if(rpfx !== 'none') { title= title + ' — '+rpfx }
*/
      let man = data.man.i;
      let mans = [];
      let manid = [];
      let kurs = [];
      let tags = [];
      let ttl = [];
      let bases_id2num = [];
      let bases_id2itm = [];
      mainPic = data.mainpic;

      man.map((i, key) => mans[i.ttl] = i);
      man.map((i, key) => manid[i.id] = i);

      
      //dispatch({type:'SET_BRANDS', payload:{ttl:mans, ids:manid}});
      data.navid.map((i, key)=>{ bases_id2num[i.id] = key });
      data.navid.map((i, key)=>{ bases_id2itm[i.id] = i });
        
      dispatch( SET_NAVBASES( {nums:bases_id2num, itms:bases_id2itm} ) );
      dispatch( LOAD_NAV_IDS(data.navid) );
      dispatch(SET_TOPNAV(data.topnav.mnu));
      dispatch(SET_LANG(lang));

      setNavIDIs({loading:false, error:false });  
      
     })
    .catch(error => { setNavIDIs({ error:error, loading:true }); })
}

function Footer() {
  return (
    <div className="footer">
        <GetInfoBlock blk="footer"/>
    </div>
  );
}

function TopTelephones(p) {
  return ( large?
        <Fragment>
             <div className="toptels">
              <div>
                <GetInfoBlock className="toptext" blk="toptext"/>
              </div>
             <GetInfoBlock blk="toptels"/>
            </div>
        </Fragment>
        : 
        null
  );
}


}
export default App;
